<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" :text="uploadMsg">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">
            <b>Edit Report</b>
          </template>
          <b-row>
            <b-col>
              <span>
                <b>
                  Report Id :
                  <span style="color:#0099ff">{{reportid}}</span>
                </b>
              </span>
            </b-col>
          </b-row>

          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12" v-if="newsuspectImage">
              <img :src="newsuspectImage" width="auto" height="150px" />
              <!-- <img v-else-if="reportimg" :src="baseURL+'/file/get/'+reportimg" width="auto" height="150px" /> -->
            </b-col>
            <b-col cols="12" v-else-if="reportimg">
              <!-- <img  :src="newsuspectImage" width="auto" height="150px" /> -->
              <img :src="baseURL+'/file/get/'+reportimg" width="auto" height="150px" />
            </b-col>
            <b-col cols="12" v-else></b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="3">
              <b-form-group>
                <b-form-file
                  v-model="suspectimage"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Select a file"
                  multiple
                  @change="showsuspectImage"
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('lastname')}">
                    <b-form-group label="Suspect Last Name *">
                      <b-form-input
                        v-model="lastname"
                        type="text"
                        id="lastname"
                        placeholder="Last Name"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('lastname')">
                        <span style="color:red;">{{validation.firstError('lastname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('firstname')}">
                    <b-form-group label="Suspect First Name *">
                      <b-form-input
                        v-model="firstname"
                        type="text"
                        id="firstname"
                        placeholder="First Name"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('firstname')">
                        <span style="color:red;">{{validation.firstError('firstname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <!-- <div :class="{error: validation.hasError('middlename')}"> -->
                  <b-form-group label="Suspect Middle Name">
                    <b-form-input
                      v-model="middlename"
                      type="text"
                      id="middlename"
                      placeholder="Middle Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('middlename')">
                        <span style="color:red;">{{validation.firstError('middlename')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('country')}">
                    <b-form-group label="Country *">
                      <b-form-select v-model="country" :options="countrylist"></b-form-select>
                      <template slot="description" v-if="validation.firstError('country')">
                        <span style="color:red;">{{validation.firstError('country')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('nationality')}">
                    <b-form-group label="Nationality *">
                      <b-form-select v-model="nationality" :options="nationlist"></b-form-select>
                      <template slot="description" v-if="validation.firstError('nationality')">
                        <span style="color:red;">{{validation.firstError('nationality')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('dateofreport')}">
                    <b-form-group label="Date">
                      <b-form-input v-model="dateofreport" type="date" id="date"></b-form-input>
                      <template slot="description" v-if="validation.firstError('dateofreport')">
                        <span style="color:red;">{{validation.firstError('dateofreport')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('lastknown')}">
                    <b-form-group label="Last Known Address *">
                      <b-form-textarea
                        id="lastknown"
                        v-model="lastknown"
                        placeholder
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <template slot="description" v-if="validation.firstError('lastknown')">
                        <span style="color:red;">{{validation.firstError('lastknown')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="6" class="text-left">
                  <div :class="{error: validation.hasError('crimeType')}">
                    <b-form-group label="Type of Crime *">
                      <b-form-select
                        v-model="crimeType"
                        :options="crimeTypes"
                        text-field="cname"
                        value-field="_id"
                      ></b-form-select>
                      <template slot="description" v-if="validation.firstError('crimeType')">
                        <span style="color:red;">{{validation.firstError('crimeType')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('crime')}">
                    <b-form-group label="Crime Synopsis *">
                      <b-form-textarea id="crime" v-model="crime" placeholder rows="3" max-rows="6"></b-form-textarea>
                      <template slot="description" v-if="validation.firstError('crime')">
                        <span style="color:red;">{{validation.firstError('crime')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="12">
                  <b-form-group label="keywords for Search">
                    <b-form-input
                      v-model="keywords"
                      type="text"
                      id="keywords"
                      placeholder="keywords, use comma as separators"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="Business Name">
                    <b-form-input
                      v-model="Businessname"
                      type="text"
                      id="Businessname"
                      placeholder="Businessname"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                 
                </b-col>

                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cname')}">
                    <b-form-group label="Contributing Name *">
                      <b-form-input v-model="cname" id="cname" placeholder="Full Name"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cname')">
                        <span style="color:red;">{{validation.firstError('cname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cemail')}">
                    <b-form-group label="Contributing Email *">
                      <b-form-input v-model="cemail" id="cemail" placeholder="Email"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cemail')">
                        <span style="color:red;">{{validation.firstError('cemail')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cphone')}">
                    <b-form-group label="Contributing Phone *">
                      <b-form-input v-model="cphone" id="cphone" placeholder="Phone Number"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cphone')">
                        <span style="color:red;">{{validation.firstError('cphone')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cagency')}">
                    <b-form-group label="Contributing Agency *">
                      <b-form-input v-model="cagency" id="cagency" placeholder="Agency"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <b-card no-header>
                <template slot="header">Other Attachments</template>

                <b-table
                  :hover="true"
                  :striped="true"
                  :bordered="false"
                  :small="false"
                  :fixed="false"
                  responsive="sm"
                  :items="Attachments"
                  :fields="receiptfields"
                >
                  <template v-slot:cell(type)="data">
                    <span v-if="data.item.attachType == 'casereport'">Case Report</span>
                    <span v-if="data.item.attachType == 'photos'">Photos</span>
                    <span v-else-if="data.item.attachType == 'fingerprints'">Finger Prints</span>
                    <span v-else-if="data.item.attachType == 'others'">Others</span>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:cell(files)="data">
                <span v-if="data.item">
                  <a
                    v-if="data.item.attachType == 'photo'|| data.item.attachType == 'fingerprints'"
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  >
                    <img
                      v-bind:src="baseURL+'/file/get/'+data.item.name"
                      width="auto"
                      height="100px"
                    />
                  </a>
                  <a
                    v-else-if="data.item.attachType == 'casereport' && filexetn(data.item.name) === false"
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  >View Report</a>
                  <a
                    v-else-if="data.item.attachType == 'others' && filexetn(data.item.name) === false"
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  >View Attachment</a>
                   <a
                    v-else
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  > <img
                      v-bind:src="baseURL+'/file/get/'+data.item.name"
                      width="auto"
                      height="100px"
                    /></a>
                  
                  
                </span>
                <span v-else>-</span>
              </template>
                  <template v-slot:cell(action)="data">
                    <b-button
                      variant="outline-danger"
                      class="mx-2"
                      size="sm"
                      @click.prevent="confirmRemoveattachment(data.item)"
                    >Delete</b-button>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newImage" :src="newImage" width="auto" height="150px" />
            </b-col>
          </b-row>

          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <span class="item_title" style="font-size:18px;font-weight:bold">Add Other Attachments</span>
            </b-col>
            <b-col cols="12" md="9">
              <div ref="messageDisplay" id="messages" v-for="(item,i) in productinfo" :key="i">
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group>
                      <b-form-select v-model="item.attachType" :options="attachmenttypes"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group>
                      <b-form-file
                        id="fileInput"
                        :plain="false"
                        v-model="item.value"
                        @change="showImage"
                      ></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="10"></b-col>
                  <b-col cols="12" md="2" style="text-align:right">
                    <span v-if="i == ''">
                      <p style="color:#ff4e00" dark @click="update">
                        <router-link to style="color:primary;padding-left:10px;">Add More</router-link>
                      </p>
                    </span>
                    <span v-if="i>0">
                      <p style="color:#ff4e00" dark @click="removee(i)">
                        <router-link to style="color:primary;padding-left:40px;">Close</router-link>
                      </p>
                    </span>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="userRole == 'admin'" class="py-2 justify-content-md-center">
            <b-form-checkbox
              id="checkbox-status"
              v-model="Confidential"
            >Check to make the report ”Strictly Confidential”, only the Admins can access and see.</b-form-checkbox>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
var marker = null;
var drawingManager;
var all_overlays = [];
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      uploadMsg: "",
      myFiles: [],
      msg: null,
      report: null,
      repoID: null,
      reportimg: null,
      lastname: null,
      firstname: null,
      middlename: null,
      country: null,
      nationality: null,
      dateofreport: null,
      lastknown: null,
      crime: null,
      cname: null,
      cemail: null,
      cphone: null,
      cagency: null,
      image: null,
      keywords: null,
      Businessname:null,
      suspectimage: null,
      newsuspectImage: null,
      newImage: null,
      reportid: null,
      crimeTypes: [],
      crimeType: null,
      Confidential: false,
      countrylist: [],
      nationlist: [],
      Attachments: [],
      receiptfields: [
        { key: "type", label: "Type ", sortable: false },
        { key: "files", label: "File", sortable: false },
        { key: "action", label: "Action", sortable: false },
      ],
      finalattachmentDetails: [],
      attachmentsformData: new FormData(),
      attachmenttypes: [
        { text: "Case Report", value: "casereport" },
        { text: "Fingerprint", value: "fingerprints" },
        { text: "Photos", value: "photos" },
        { text: "Other", value: "others" },
      ],
      productinfo: [
        {
          attachType: "",
          originalName: null,
          value: null,
        },
      ],
      attachments: [],
      getAttachments: [],
      attachmentset: [],
      attachpercentCompleted: null,
      imagepercentCompleted: null,
      formupdate:false,
      suspectupload:false,
      attachupload:false,
      userRole: localStorage.getItem("role"),
    };
  },
  computed: {
    availableOptions() {
      return this.elephants.filter(
        (opt) => this.forms[this.elephantIndex].value.indexOf(opt) === -1
      );
    },
  },
  watch:{
    formupdate(){
      if(this.formupdate == false &&
      this.suspectupload == false &&
      this.attachupload == false)
      {
      this.appLoading = false;
      this.$router.go(-1);
      }
      
      else
      this.appLoading = true;
    },
    suspectupload(){
      if(this.formupdate == false &&
      this.suspectupload == false &&
      this.attachupload == false)
      {
      this.appLoading = false;
      this.$router.go(-1);
      }
      else
      this.appLoading = true;
    },
     attachupload(){
      if(this.formupdate == false &&
      this.suspectupload == false &&
      this.attachupload == false)
      {
      this.appLoading = false;
      this.$router.go(-1);
      }
      else
      this.appLoading = true;
    }
  },
  beforeMount() {
    this.getData();
    this.getcrimeType();
    this.getcountrylist();
    this.getnationlist();
  },
  validators: {
    lastname(value) {
      return this.Validator.value(value).required("Required Field");
    },
    firstname(value) {
      return this.Validator.value(value).required("Required Field");
    },
    // middlename(value) {
    //   return this.Validator.value(value).required("Required Field");
    // },
    country(value) {
      return this.Validator.value(value).required("Required Field");
    },
    nationality(value) {
      return this.Validator.value(value).required("Required Field");
    },
    lastknown(value) {
      return this.Validator.value(value).required("Required Field");
    },
    // age(value) {
    //   return this.Validator.value(value)
    //     .required("Required Field")
    //     .regex("^(?=.*[0-9])", "Please Input Valid Age.");
    // },
    crimeType(value) {
      return this.Validator.value(value).required("Required Field");
    },
    crime(value) {
      return this.Validator.value(value).required("Required Field");
    },
    dateofreport(value) {
      return this.Validator.value(value).required("Required Field");
    },
    cname(value) {
      return this.Validator.value(value).required("Required Field");
    },
    cemail(value) {
      return this.Validator.value(value).required("Required Field").email();
    },
    cphone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[0-9]*$", "Please Input Valid Number.");
    },
    cagency(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  methods: {
    inputCheck() {
      for (var i = 0; i < this.productinfo.length; i++) {
        if (this.productinfo[i].value != null) {
          this.productinfo[i].originalName = this.productinfo[i].value.name;
          this.productinfo[i].value = null;
        }
      }

      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.editReport();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },

    getreportId() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/available/reportid",
      })
        .then((response) => {
          this.appLoading = false;
          this.repoID = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getcrimeType() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/crimetype/list",
      })
        .then((response) => {
          this.appLoading = false;
          this.crimeTypes = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },

    getcountrylist() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/countries",
      })
        .then((response) => {
          this.appLoading = false;
          this.countrylist = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getnationlist() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/nationalities",
        // params: {
        //   id: this.$route.params.id,
        // },
        // headers: {
        //   "x-auth-token": localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.nationlist = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/report/view/" + this.$route.params.id,
        // params: {
        //   id: this.$route.params.id,
        // },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.report = response.data.data;
          this.reportid = this.report.reportID;
          this.reportimg = this.report.photo;
          this.dateofreport = this.formatDate(this.report.added_date);
          // console.log(this.dateofreport);
          this.lastname = this.report.suspectLastName;
          this.firstname = this.report.suspectFirstName;
          this.middlename = this.report.suspectMiddleName;
          this.country = this.report.country;
          this.nationality = this.report.nationality;
          this.lastknown = this.report.knownAddress;
          this.crime = this.report.crimeSynopsis;
          this.Businessname = this.report.businessName;
          this.cname = this.report.contributingName;
          this.cemail = this.report.contributingEmail;
          this.cphone = this.report.contributingPhone;
          this.cagency = this.report.contributingAgency;
          this.keywords = this.report.searchKeywords;
          this.crimeType = this.report.crimeTypeId._id;
          this.Confidential = this.report.isConfidential;
          this.getAttachments = this.report.attachments;
          var attach = {
            attachType: "",
            value: "",
          };
          // for (var i = 0; i < this.getAttachments.length; i++) {
          //   attach = {
          //     attachType: "",
          //     value: "",
          //   };
          //   attach.attachType = this.getAttachments[i].attachType;
          //   attach.value = this.getAttachments[i].name;

          //   this.productinfo.push(attach);
          // }
          this.Attachments = this.report.attachments;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },

    editReport() {
      // this.appLoading = true;
      this.formupdate=true;
      var data = {};
      data["suspectLastName"] = this.lastname;
      data["suspectFirstName"] = this.firstname;
      data["suspectMiddleName"] = this.middlename;
      data["knownAddress"] = this.lastknown;
      data["country"] = this.country;
      data["nationality"] = this.nationality;
      data["added_date"] = this.dateofreport;
      data["crimeSynopsis"] = this.crime;
      data["businessName"] = this.Businessname;
      data["contributingName"] = this.cname;
      data["contributingEmail"] = this.cemail;
      data["contributingPhone"] = this.cphone;
      data["contributingAgency"] = this.cagency;
      data["searchKeywords"] = this.keywords;
      data["crimeTypeId"] = this.crimeType;
      data["isConfidential"] = this.Confidential;
      axios({
        method: "POST",
        url: "/report/edit/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status) {
            this.reportid = response.data.Rid;
            var isok = false;
            if (this.suspectimage) {
              isok = true;
              this.uploadsuspectImage(this.productinfo.length);
            }
            if (this.attachmentset.length > 0) {
              
              isok = true;
              for (var i = 0; i < this.attachmentset.length; i++) {
                this.attachmentsformData.append(
                  "attachments",
                  this.attachmentset[i]
                );
              }
              this.uploadattachments();
            }

            // if (isok == false) {
            //   this.$router.go(-1);
            // }
          } else {
            this.msg = response.data.msg;
          }
          this.formupdate = false;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    update() {
      this.productinfo.push({
        attachType: null,
        originalName: null,
        value: null,
      });
      // console.log(this.productinfo)
    },
    removee(index) {
      this.productinfo.splice(index, 1);
      this.attachments.splice(index, 1);
      this.attachmentset.splice(index, 1);
    },

    showsuspectImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      var fileData = event.target.files[0];
      var fileName = fileData.name;

      if (!files.length) {
        this.newsuspectImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";
        return;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        this.newsuspectImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },

    showImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      var fileData = event.target.files[0];
      var selectedFiles = e.target.files[0];
      var fileName = fileData.name;
      var filetype = fileData.type;
      // console.log(fileData)
      // console.log(selectedFiles)
      if (!files.length) {
        this.newImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";

        return;
      } else {
        this.msg = null;
        this.attachmentset.push(selectedFiles);

        // this.attachmentsformData.append("attachments", selectedFiles);
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        if (filetype === "image/png" || "image/jpg" || "image/jpeg")
          this.newImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },

    uploadsuspectImage(count) {
      var vm = this;
       this.suspectupload=true;
      // this.appLoading = true;
      let formData = new FormData();
      formData.append("photo", vm.suspectimage[0]);

      axios({
        method: "POST",
        url: "/report/upload/photo/" + this.$route.params.id,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
        data: formData,
        onUploadProgress: function (progressEvent) {
          this.imagepercentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          // vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
          // this.appLoading = false;
          // if (this.attachmentset.length == 0) 
          // this.$router.go(-1);
          this.suspectupload=false;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

    uploadattachments() {
      var vm = this;
      this.attachupload=true;
      // this.appLoading = true;
      var data = {};
      this.attachmentsformData.append(
        "attachmentDetails",
        JSON.stringify(this.productinfo)
      );

      axios({
        method: "POST",
        url: "/report/upload/attachments/" + this.$route.params.id,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },

        data: this.attachmentsformData,
        onUploadProgress: function (progressEvent) {
          this.attachpercentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          // vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
          // this.appLoading = false;
          this.attachupload=false;
          
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

    confirmRemoveattachment(evnt) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to Remove this attachment.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            var id = evnt._id;
            this.removeProduct(id);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    removeProduct(pid) {
      axios({
        method: "POST",
        url: "/report/attachment/remove/" + pid,
        params: {
          id: pid,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getData();
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },

    filexetn(extfile){
       var file= extfile;
       var reg = /(.*?)\.(jpg|bmp|jpeg|png)$/;
       if(!file.match(reg))
       {
    	   
    	   return false;
       }
       },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = year + "-" + dt.slice(4, 7) + "-" + day;
      return strTime;
    },
  },
};
</script>
<style scoped>
#map {
  height: 400px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>